// extracted by mini-css-extract-plugin
export var numberInputContainer = "_5y-0";
export var startPickingButton = "_5y-1";